import React from 'react';
import LoadingOverlay from 'react-loading-overlay';

const LoadingComponent = ({ loading }) => {
	return <LoadingOverlay active={loading} spinner className="overlay" />;
};

export default LoadingComponent;
